var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "none",
    d: "m0,0l24,0l0,24l-24,0l0,-24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    d: "m9.48097,16.20877l1.72476,1.72476l6.11618,-6.11618l-6.11618,-6.11618l-1.72476,1.72476l3.15595,3.16818l-11.8287,0l0,2.44647l11.8287,0l-3.15595,3.16818zm10.89904,-15.40055l-17.12532,0c-1.35779,0 -2.44647,1.10091 -2.44647,2.44647l0,4.89295l2.44647,0l0,-4.89295l17.12532,0l0,17.12532l-17.12532,0l0,-4.89295l-2.44647,0l0,4.89295c0,1.34556 1.08868,2.44647 2.44647,2.44647l17.12532,0c1.34556,0 2.44647,-1.10091 2.44647,-2.44647l0,-17.12532c0,-1.34556 -1.10091,-2.44647 -2.44647,-2.44647z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolExit);
export default __webpack_public_path__ + "static/media/tool-exit.32015cbf8eb2bad45c483ff8fa68a9cc.svg";
export { ForwardRef as ReactComponent };